import { __require as n } from "./main34.js";
var e, t;
function f() {
  if (t) return e;
  t = 1;
  var i = n(), a = (function() {
    try {
      var r = i(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return e = a, e;
}
export {
  f as __require
};
